function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "google_provider_a",
  cx: "5.644%",
  cy: "-354.17%",
  r: "646.47%",
  fx: "5.644%",
  fy: "-354.17%",
  gradientTransform: "scale(.36498 1) rotate(30 .106 -3.358)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#4387FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "65%",
  stopColor: "#3078F0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "90.99%",
  stopColor: "#2B72EA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#286EE6"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "google_provider_b",
  cx: "-15.599%",
  cy: "-89.033%",
  r: "345.036%",
  fx: "-15.599%",
  fy: "-89.033%",
  gradientTransform: "scale(.83778 1) rotate(30 -.171 -.947)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFD24D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F6C338"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0DA960",
  d: "M13.928 74.755L0 50.64 26.072 5.46 40 29.576z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#google_provider_a)",
  d: "M13.928 69.755L27.856 45.64H80L66.072 69.755z",
  transform: "translate(0 5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#google_provider_b)",
  d: "M80 45.64H52.144L26.072.46h27.856z",
  transform: "translate(0 5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D6FDD",
  d: "M40 50.64H27.856l6.043-10.532-19.971 34.647z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E5B93C",
  d: "M52.144 50.64H80L46.101 40.108z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0C9B57",
  d: "M33.899 40.108L40 29.576 26.072 5.46z"
}));

var SvgGoogleDriveProviderIco = function SvgGoogleDriveProviderIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleDriveProviderIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google_drive_provider_ico.af0d5a5e.svg";
export { ForwardRef as ReactComponent };